import { requestApi } from '@app/api';
import { withSubscription } from '@app/api/paths';

import { Subscription } from '..';

export type ActivateSubscriptionResponse = Subscription;

export function activateSubscription(workspaceId: string) {
  return requestApi<ActivateSubscriptionResponse>({
    url: withSubscription(`/workspaces/${workspaceId}/subscription/activation`),
    method: 'POST',
    credentials: true,
  }).then((response) => response.data);
}
